import { render, staticRenderFns } from "./ColorTab.vue?vue&type=template&id=1fc23a74&scoped=true&"
import script from "./ColorTab.vue?vue&type=script&lang=js&"
export * from "./ColorTab.vue?vue&type=script&lang=js&"
import style0 from "./ColorTab.vue?vue&type=style&index=0&id=1fc23a74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc23a74",
  null
  
)

export default component.exports